import React, { useState } from 'react';

const TemplateSelectionCard = ({ template, index, handleTemplateSelect, isSelected }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      key={index}
      style={{
        width: '300px',
        height: '200px',
        overflow: 'hidden',
        cursor: 'pointer',
        borderRadius:'10px',
        backgroundImage: `url(data:image/jpeg;base64,${template.screenshot})`,
        backgroundSize: 'cover', // Optionally add background size cover to fill the div
        backgroundPosition: 'top', // Optionally center the background image
        border: isHovered ? '2px solid #65BBE6' : isSelected ? '3px solid #0094DC' : '1px solid grey',
        transition: 'border-color 0.3s ease',
        position:'relative'
      }}
      onClick={() => handleTemplateSelect(template)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      

      {isHovered && (
        <div
          style={{
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.5)', // Black with 50% opacity
            position: 'absolute',
            top: 0,
            left: 0,
            color:'white',
            display:'flex',
            alignItems:'center',
            justifyContent:'center'
          }}
        >
          Use this Template
        </div>
      )}

{isSelected && (
        <div
          style={{
            width: '100%',
            height: '100%',
            background: 'rgba(0, 148, 220, 0.5)', // Black with 50% opacity
            position: 'absolute',
            top: 0,
            left: 0,
            color:'white',
            display:'flex',
            alignItems:'center',
            justifyContent:'center'
          }}
        >
          Selected
        </div>
      )}
    </div>
  );
};

export default TemplateSelectionCard;
